import { useReducer } from 'react';

import { formatBRLCurrencyAsNumber } from 'lib/number';

import OFFER from 'constants/offer';

const useOffersFiltersState = (
  initialValue = {
    priceRange: { min: null, max: null },
    stores: [],
    venue: null,
  }
) =>
  useReducer((state, action) => {
    switch (action.type) {
      case OFFER.FILTER_ACTION_TYPES.PRICE_RANGE:
        return {
          ...state,
          priceRange: {
            ...state.priceRange,
            min:
              action.priceRange.min !== ''
                ? formatBRLCurrencyAsNumber(action.priceRange.min)
                : null,
            max:
              action.priceRange.max !== ''
                ? formatBRLCurrencyAsNumber(action.priceRange.max)
                : null,
          },
        };

      case OFFER.FILTER_ACTION_TYPES.REMOVE_PRICE_RANGE:
        return { ...state, priceRange: { min: null, max: null } };

      case OFFER.FILTER_ACTION_TYPES.STORES:
        return { ...state, stores: action.stores };

      case OFFER.FILTER_ACTION_TYPES.REMOVE_STORE:
        return {
          ...state,
          stores: state.stores.filter(
            ({ storeId }) => storeId !== action.storeId
          ),
        };

      case OFFER.FILTER_ACTION_TYPES.VENUE:
        return {
          ...state,
          venue: state.venue !== action.venue ? action.venue : null,
        };

      case OFFER.FILTER_ACTION_TYPES.REMOVE_VENUE:
        return { ...state, venue: null };

      case OFFER.FILTER_ACTION_TYPES.RESET:
        return initialValue;

      default:
        return state;
    }
  }, initialValue);

export default useOffersFiltersState;
